import {ReactElement, useMemo} from "react";
import {RenderAuditLogsEnrichment, RendererProps} from "../RendererProps";
import {ensureNotObject, formatBudgetYearAndVersionType} from "../common";
import * as common from "../styles/common.module.scss";

const VALUE_MONTH_VARS: Record<string, string> = {
    "ovM0": "Month 1",
    "ovM1": "Month 2",
    "ovM2": "Month 3",
    "ovM3": "Month 4",
    "ovM4": "Month 5",
    "ovM5": "Month 6",
    "ovM6": "Month 7",
    "ovM7": "Month 8",
    "ovM8": "Month 9",
    "ovM9": "Month 10",
    "ovM10": "Month 11",
    "ovM11": "Month 12"
};

function hasChange(parsedVariables: Record<string, unknown>): boolean {
    return Array.isArray(parsedVariables["unitTypeOverrides"]) && parsedVariables["unitTypeOverrides"].length > 0;
}

export interface RenderSetOriginalRevenueMarketRentOverridesGranularProps extends RendererProps {
    enrichment?: RenderAuditLogsEnrichment;
}

export function RenderSetOriginalRevenueMarketRentOverridesGranular(props: RenderSetOriginalRevenueMarketRentOverridesGranularProps): ReactElement {
    const unitTypeMap = useMemo(() => {
        if(props.enrichment) {
            return props.enrichment.unitTypes.toIdMap(u => u.id);
        }
        return {};
    }, [props.enrichment]);

    if(!hasChange(props.variables)) {
        return <div>No change</div>;
    }

    const renderOverrides = (parsedVariables: Record<string, unknown>) => {
        const unitTypeOverrides = parsedVariables["unitTypeOverrides"];
        if(!Array.isArray(unitTypeOverrides)) {
            return [];
        }

        const overrides = [];
        for(const val of unitTypeOverrides) {
            for(const entry of Object.entries(VALUE_MONTH_VARS)) {
                const [key, value] = entry;
                const overrideVal = val[key];
                if(overrideVal !== undefined) {
                    const utId = val["unitTypeId"];
                    const ut = unitTypeMap[utId];
                    overrides.push(<div key={`${utId}-${key}`} className={common.section}>
                        <div>Unit Type: {ensureNotObject(ut ? ut.name : "UNKNOWN")}</div>
                        <div>{value}: {overrideVal === null ? "Override Removed" : ensureNotObject(overrideVal)}</div>
                    </div>);
                }
            }
        }
        return overrides;
    };

    return <div>
        <div className={common.textHeader}>{formatBudgetYearAndVersionType(props.variables["budgetYear"], props.variables["versionType"])}</div>
        {renderOverrides(props.variables)}
    </div>;
}